export { default as CopyToClipboard } from './copy-to-clipboard'
